export default __webpack_public_path__ + "static/media/research-arrow-desktop.b1f1962d.svg";